export interface ProfileData {
  address?: string; city?: string; state?: string; country?: string; zip_code?: string;
  date_of_birth?: string; gender?: string; nationality?: string; marital_status?: string;
  linkedin?: string; github?: string; facebook?: string; twitter?: string;
  instagram?: string; tiktok?: string; website?: string;
  salary_min?: number; salary_max?: number; salary_currency?: string;
  education_history?: Array<{ school: string; degree: string; year: string }>;
  work_experience?: Array<{ company: string; title: string; from: string; to: string; description: string }>;
  character_references?: CharacterReference[];
}

export interface EmergencyContact { id?: number; name: string; relationship: string; phone?: string; email?: string; address?: string }
export interface Dependent { id?: number; name: string; relationship: string; date_of_birth?: string; notes?: string }
export interface Document { id?: number; doc_type: string; doc_name?: string; status?: string; notes?: string }
export interface CharacterReference { name: string; position?: string; company?: string; phone?: string; email?: string }

export const DOC_TYPES = ["SSS", "PhilHealth", "Pag-IBIG", "NBI Clearance", "Medical", "TIN", "Diploma", "Driver's License", "Passport", "Valid ID", "Other"];

export type SaveFn = (d: Record<string, unknown>) => void;

export interface EditableTabProps {
  editing: boolean;
  onEdit?: () => void;
  onSave: SaveFn;
  onCancel: () => void;
  saving: boolean;
}
